export const GET_BOOKING_DATA_SUCCESS = 'GET_BOOKING_DATA_SUCCESS';
export const GET_BOOKING_AVAILABILITY_SUCCESS = 'GET_BOOKING_AVAILABILITY_SUCCESS';

export const API_CALL_INPROGRESS = 'API_CALL_INPROGRESS';
export const JOBID_NOT_FOUND = 'JOBID_NOT_FOUND';
export const CONFIRM_BOOKING_ERROR = 'CONFIRM_BOOKING_ERROR';
export const GET_CONTACT_INFO_SUCCCESS = 'GET_CONTACT_INFO_SUCCCESS';
export const GET_JOB_DATA_SUCCESS = 'GET_JOB_DATA_SUCCESS';

export const BOOKING_STATUSES = {
    PENDING: 'PENDING',
    IN_TRANSIT: "IN TRANSIT",
    COMPLETE: "COMPLETE",
    BOOKED: "BOOKED",
    ERROR: "ERROR"
};

export const INTERNAL_STATUSES = {
    REBOOK: 'rebook',
    UPDATE_ADDRESS: 'updateAddress'
};

export const INTEGRATED_SURVEY = {
    id: 1,
    title: "Integrated Setup Questionnaire",
    questions: {
        "connectionMethod": {
            prompt: "The pin pad will connect to the POS via:",
            promptShort: "Connection Method",
            value: "",
            order: 1,
            control: {
                type: "radiobutton",
                options: [
                    { id: "a", label: "USB", value: "USB" },
                    { id: "b", label: "Serial", value: "Serial" }
                ]
            }
        },
        "hasKeyboardOrMouse": {
            prompt: "Do you have access to keyboard/mouse for the POS:",
            promptShort: "Keyboard/Mouse",
            value: "",
            order: 2,
            control: {
                type: "radiobutton",
                options: [
                    { id: "a", label: "Yes", value: "Yes" },
                    { id: "b", label: "No", value: "No" }
                ]
            }
        },
        "hasExternalITSupport": {
            prompt: "Do you have an external IT Support:",
            promptShort: "External IT Support",
            value: "",
            order: 3,
            control: {
                type: "radiobutton",
                options: [
                    { id: "a", label: "Yes", value: "Yes" },
                    { id: "b", label: "No", value: "No" }
                ]
            }
        },
        "siteSetup": {
            prompt: "Which best describes your site setup:",
            promptShort: "Site Setup",
            value: "",
            order: 4,
            control: {
                type: "radiobutton",
                options: [
                    { id: "a", label: "Back Office", value: "Back Office" },
                    { id: "b", label: "Individual POS", value: "Individual POS" }
                ]
            }
        },
        "operatingSystem": {
            prompt: "What operating system is installed on the POS:",
            promptShort: "Operating System",
            value: "",
            order: 5,
            control: {
                type: "input",
                placeholder: "Eg. Windows 10",
                validation: ["required"]
            }
        }
    },
    style: {
        survey: { header: "integrated-survey-header" },
        questions: {
            prevButton: "m-b-5",
            statusBar: "alert alert-info status-bar",
            submitButton: "btn btn-client btn-lg btn-block",
            summary: {
                table: "table table-striped table-bordered text-left",
                editButton: "btn btn-grey btn-xs",
                editButtonIcon: "fa fa-edit m-r-0"
            }
        }
    }
};

export const INTEGRATED_SURVEY_Q3 = {
  id: 1,
  title: "Integrated Setup Questionnaire",
  questions: {
    "hasKeyboardOrMouse": {
      prompt: "Do you have access to keyboard/mouse for the POS:",
      promptShort: "Keyboard/Mouse",
      value: "",
      order: 1,
      control: {
        type: "radiobutton",
        options: [
          { id: "a", label: "Yes", value: "Yes" },
          { id: "b", label: "No", value: "No" }
        ]
      }
    },
    "hasExternalITSupport": {
      prompt: "Do you have an external IT Support:",
      promptShort: "External IT Support",
      value: "",
      order: 2,
      control: {
        type: "radiobutton",
        options: [
          { id: "a", label: "Yes", value: "Yes" },
          { id: "b", label: "No", value: "No" }
        ]
      }
    }
  },
  style: {
    survey: { header: "integrated-survey-header" },
    questions: {
      prevButton: "m-b-5",
      statusBar: "alert alert-info status-bar",
      submitButton: "btn btn-client btn-lg btn-block",
      summary: {
        table: "table table-striped table-bordered text-left",
        editButton: "btn btn-grey btn-xs",
        editButtonIcon: "fa fa-edit m-r-0"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/booking/constants/bookingConstants.js